import React from "react";
import { FlameIcon } from "lucide-react";
export function AnnouncementBar() {
  return <div className="w-full overflow-hidden bg-red-600 text-white" data-id="element-20" data-mp="oka9it0f6vgc">
      <div className="flex whitespace-nowrap py-2 text-xs font-semibold uppercase tracking-wider sm:text-sm" data-id="element-21" data-mp="on66of4g1g3q">
        <div className="animate-marquee flex shrink-0 items-center" data-id="element-22" data-mp="ev0ep5e6yyoj">
          {Array.from({
          length: 6
        }).map((_, i) => <span key={i} className="mx-6 flex items-center gap-2" data-id="element-23" data-mp="9w5zsejchu9p" data-mpi={i}>
              <FlameIcon className="h-4 w-4" data-id="element-24" data-mp="5uc1gcwmh2cp" />
              Oferta de lanzamiento · Solo para los primeros 100 · El precio sube pronto
            </span>)}
        </div>
        <div className="animate-marquee flex shrink-0 items-center" aria-hidden="true" data-id="element-25" data-mp="xbu7yo1dtk0">
          {Array.from({
          length: 6
        }).map((_, i) => <span key={i} className="mx-6 flex items-center gap-2" data-id="element-26" data-mp="1v9s91nuweg0h" data-mpi={i}>
              <FlameIcon className="h-4 w-4" data-id="element-27" data-mp="1v6wapyf51pbi" />
              Oferta de lanzamiento · Solo para los primeros 100 · El precio sube pronto
            </span>)}
        </div>
      </div>
    </div>;
}